import { Descriptions } from 'antd';
import React from 'react';
import { useMeterModels } from 'hooks/meter_models/useMeterModels';
import { commodityTranslated } from 'components/Form/meter_details/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { InventoryMeterMountType } from '@enmon/commons/lib/tools';
import { BuildingFloor } from 'components/BuildingFloor/BuildingFloor';
import { selectMeterModel, useStore } from '../../../useStore';
import { ImageUploadReview } from '../../../../../components/ImageUpload/ImageUploadReview';
import { LocationDescriptions as messages } from '../messages';

export const LocationDescriptions: React.VFC = () => {
  const intl = useIntl();
  const {
    buildingFloor,
    apiKey,
    meterMountType,
    remoteReadingOwner,
    newMeter,
    locationBuilding,
    locationBuildings,
    meterOwner,
    meterTenant,
    commodity,
    internalSupplyPointCode,
    monitoredEntity,
    photoContextList,
  } = useStore();
  const { meterModels } = useMeterModels(commodity);
  const { meterModel } = useStore(selectMeterModel(meterModels));
  const meterModelName = meterModel?.name ?? intl.formatMessage(messages.meterModelNotSpecified);

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
      size="small"
      title={<FormattedMessage {...messages.title} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.photoContext} />} span={2}>
        <ImageUploadReview fileList={photoContextList} previewWidth={150} />
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.commodity} />}>
        {commodity ? intl.formatMessage(commodityTranslated[commodity]) : ''}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.newMeter} />}>
        <FormattedMessage {...messages.newMeterStatus} values={{ value: newMeter }} />
      </Descriptions.Item>

      {meterMountType && meterMountType !== InventoryMeterMountType.Free && (
        <Descriptions.Item label={<FormattedMessage {...messages.remoteReadingOwner} />}>
          {remoteReadingOwner}
        </Descriptions.Item>
      )}
      <Descriptions.Item label={<FormattedMessage {...messages.apiKey} />}>{apiKey}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.meterModelLabel} />}>{meterModelName}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.monitoredEntity} />}>
        {monitoredEntity}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.building} />}>
        {locationBuildings?.find(building => building.id === locationBuilding)?.name ??
          intl.formatMessage(messages.outsideNotSpecified)}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.floor} />}>
        <BuildingFloor level={buildingFloor} />
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.owner} />}>{meterOwner}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.internalSupplyPointCode} />}>
        {internalSupplyPointCode}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.tenant} />}>{meterTenant}</Descriptions.Item>
    </Descriptions>
  );
};
